import _debug from 'debug';
import $ from 'jquery';
import { showError } from 'plugins/sse';

require('eventsource-polyfill');

export const SSE_MESSAGE = 'SSE_MESSAGE';
export const SSE_ERROR = 'SSE_ERROR';

const debug = _debug('app::sse');

let sseFeed;
let sseListeners = [];

export function connectSSE() {
  // Resolving url
  const url = $('#sse-error-modal').attr('data-url');

  // Connecting
  if (url && url.length && !sseFeed) {
    debug(`Connecting to SSE at address ${url}`);
    sseFeed = new EventSource(url);

    sseFeed.addEventListener(
      'error',
      error => {
        console.error('SSE stream error', error);

        showError();
      },
      false
    );

    addMessageListener(sseFeed, json => {
      sseListeners.forEach(listener => listener(json));
    });

    // Closing channel when leaving page
    $(window).on('beforeunload', () => sseFeed.close());
  }
}

export function addListener(listener) {
  sseListeners.push(listener);
}

export function connectToReduxStore(store) {
  if (sseFeed) {
    addMessageListener(sseFeed, json => {
      store.dispatch({
        type: SSE_MESSAGE,
        payload: {
          event: json,
        },
      });
    });

    sseFeed.addEventListener(
      'error',
      error => {
        store.dispatch({
          type: SSE_ERROR,
          payload: {
            error,
          },
        });
      },
      false
    );
  }

  return store;
}

function addMessageListener(sseFeed, listener) {
  sseFeed.addEventListener(
    'message',
    ({ data }) => {
      const json = JSON.parse(data);
      if (json && json._type) {
        debug(`SSE stream message ${json}`);
        debug(json);

        listener(json);
      }
    },
    false
  );
}



// WEBPACK FOOTER //
// ./src/services/sse.js